import { render, staticRenderFns } from "./plafonMajority.vue?vue&type=template&id=7e64315d&"
import script from "./plafonMajority.vue?vue&type=script&lang=js&"
export * from "./plafonMajority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports